




















import Vue from "vue";

import { DictationCorrectedTile } from "../../models/control";

import JzChatMsg from "./JzChatMsg.vue";
import { PropsIsCorrect, PropsIsChatMessage } from "../../models/chat";
import { propsDefIsCorrect } from "../../constants/chat";

interface Props extends PropsIsCorrect, PropsIsChatMessage {
  userAnswer: DictationCorrectedTile[];
}

/**
 * As of April 2020, only bot can send image messages
 */
export default Vue.extend<{}, {}, {}, Props>({
  name: "JzChatDictationAnswer",
  components: { JzChatMsg },

  props: {
    ...propsDefIsCorrect,
    avatarUrl: { type: String, default: undefined },
    type: { type: String, default: "user" },
    userAnswer: {
      type: Array as () => DictationCorrectedTile[],
      required: true
    }
  }
});
